import { Observable } from 'rxjs/Rx';
import { Component, OnInit, Input, Output, ViewChild, OnDestroy } from '@angular/core';
import { ToolService, ToolTypeService, ToolDescriptionByTypeService, PlantOccurrenceService } from '../../../camtl.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { Tool } from '../../../../../shared/model';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { MasterToolListBase } from '../../master-tool-list-base.component';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { Subscription } from 'rxjs/Subscription';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-system-layout',
    templateUrl: './system-layout.component.html',
    // styleUrls: ['./system-layout.component.scss']
})

export class SystemLayoutComponent extends MasterToolListBase implements OnInit, OnDestroy {

    constructor(
        toolTypeService: ToolTypeService,
        public service: ToolService,
        private systemSelectService: SystemSelectService,
        private plantOccurrenceService: PlantOccurrenceService,
        public toolDescriptionService: ToolDescriptionByTypeService,
        private cgpSnackbarService: CgpSnackbarService,
        private cgpAlertDialogService: CgpAlertDialogService,
        private formBuilder: FormBuilder,
        public routeValidationService: RouteValidationService) {
        super(toolTypeService, "System Layout", toolDescriptionService);
    }

    editForm: FormGroup;
    isNew: boolean = false;
    editDataItem: Tool;
    toolNumbers: any[] = [];
    systemSubscription: Subscription;
    disableActions: boolean = false;
    @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

    private ngUnsubscribe: Subject<void> = new Subject<void>();

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    columns: any[] = [{
        field: "ToolDetail.ToolNumber",
        title: "Tool Number",
    }, {
        field: 'ToolDescription',
        title: 'Description'
    }, {
        field: "PlantOccurrenceName",
        title: "Plant Occurrence"
    },
    {
        field: "AdditionalInfo",
        title: "Additional Info"
    }];



    ngOnInit() {
        var self = this;
        this.editForm = this.formBuilder.group({
            Id: [],
            ToolNumber: [{ value: [] }],
            ToolDescriptionId: [{ value: [] }, Validators.required],
            PlantOccuranceId: [{ value: [] }, Validators.required],
            AdditionalInfo: [""],
            SystemId: [""],
            MakeFurnish: [""],
            ToolTypeId: [],
            JobNumber: [],
            CreatedBy: [],
            CreatedDate: []
        })

        this.systemSelectService.system$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(system => {
                this.system = system;
                this.editDataItem = undefined;
                if (this.system && this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
                    this.template.controls.add = false;
                    this.template.controls.edit = false;
                    this.template.controls.delete = false;
                }
                else {
                    this.template.controls.add = true;
                    this.template.controls.edit = true;
                    this.template.controls.delete = true;
                }
            });

        this.systemSelectService.get();
    }


    onSave = (dataItem, isNew) => {
        var self = this;
        self.service.save(dataItem, isNew, "", true, false)
            .then(function () {
                self.grid.refresh(true);
                self.cgpSnackbarService.showSnackbar({
                    message: isNew ? "Record has been created" : "Record has been updated",
                    duration: 2000
                });
            }).catch(function (response) {
                self.service.loading.next(false);
                self.cgpAlertDialogService.showAlertDialog({
                    title: 'Error',
                    message: response.error.Message,
                    alert: 'danger',
                    closeLabel: 'Close',
                })
            })
    }

    onRead = (): Promise<any> => {
        var self = this;
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/SystemLayout')) {
            this.plantOccurrenceService.read("", true);
            return this.toolTypeService.read()
                .then(function (response: any) {
                    self.systemLayoutId = response.filter(function (item) {
                        return item.Description.toUpperCase() === "SYSTEM LAYOUT";
                    })[0].Id;

                    return self.toolDescriptionService.read("/" + self.systemLayoutId + '/toolDescription', true).then(function () {
                        return self.service.read('/' + self.system.Id + "/toolType/" + self.systemLayoutId, true).then(function (response) {
                            for (var i = 0; i < response.length; i++) {
                                response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
                            }
                            return response;
                        });
                    });

                })

        }
    }

    disableToolbar = (controlName: string) => {
        let isDisabled: boolean = false;
        if (!this.systemLayoutId && controlName === "add") {
            isDisabled = true;
        }
        return isDisabled;
    }


    handleDelete = (dataItem): Promise<any> => {
        return this.service.remove('/' + dataItem.Id);
    }


    template = {
        controls: {
            add: true,
            edit: true,
            delete: true,
            excel: true,
            isDisabled: this.disableToolbar
        },
        read: this.onRead,
        delete: this.handleDelete,
        columns: this.columns,
        service: this.service,
        save: this.onSave,
        fileName: "system_layout_tools.xlsx",
        displayField: "DisplayNumber"
    };


    formDialog = {
        title: "System Layout",
        formControls: [
            {
                type: 'combobox',
                name: "ToolDescriptionId",
                title: "Tool Description",
                placeholder: 'Select Tool Description',
                textField: "Name",
                valueField: "Id",
                service: this.toolDescriptionService,
                width: 250
            },
            {
                type: 'combobox',
                name: "PlantOccuranceId",
                title: "Plant Occurrence",
                placeholder: 'Select Plant Occurrence',
                textField: "Name",
                valueField: "Id",
                service: this.plantOccurrenceService,
                width: 250
            },
            {
                type: "text",
                name: "AdditionalInfo",
                title: "Additional Info"
            },
        ]
    }

    setModelHandler() {
        this.editDataItem = new Tool();
        this.editDataItem.ToolTypeId = this.systemLayoutId;
        this.editDataItem.MakeFurnish = "M";
        this.editDataItem.JobNumber = 0;

        if (this.system) {
            this.editDataItem.SystemId = this.system.Id;

        }
    }
}
